import React, { Component } from 'react';
import _ from 'lodash';

import { Settings as SettingsIcon } from '@material-ui/icons';

import { withStyles } from '@material-ui/core/styles';
import ReactDOM from 'react-dom';

import {
	WithStyles,
	createStyles,
} from '@material-ui/core';


import { MyPATPopMenu, MenuData } from '../../common';
import ACLService from '../../acl/services/aclService'
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { PERMISSION_CONTENT_TYPES, PERMISSION_TEST_CONTENT_TYPES, USER_RIGHTS } from '../../../constants/comman';
const styles = createStyles({

});

interface ContentTopMenuProps extends WithStyles<typeof styles> {
	isIndicator: boolean;
	handleRepublishQueue: Function
}
interface ContentTopMenuState {
}

class ContentTopMenu extends Component<ContentTopMenuProps, ContentTopMenuState>{

	checkTemplateDisable = (): any => {
		const testModulesAcess = PERMISSION_TEST_CONTENT_TYPES.some(module => ACLService.checkModulePermission(module, USER_RIGHTS.CREATE));
		const hasTemplateAccess = [USER_RIGHTS.CREATE, USER_RIGHTS.VIEW].some(right => ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.DEFAULT_TEST_TEMPLATE, right)) || [USER_RIGHTS.CREATE, USER_RIGHTS.VIEW].some(right => ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.CUSTOM_TEST_TEMPLATE, right));
		return !(testModulesAcess && hasTemplateAccess);
	}

	menuItems: MenuData[] = [{
		type: 'redirect',
		id: 1,
		to: "/tag-management",
		img: "/assets/svg/myLibrary/settings-menu/tag-icon.svg",
		text: "Tag Management"
	},
	{
		type: 'redirect',
		id: 2,
		to: "/test-template",
		img: "/assets/svg/myLibrary/settings-menu/template-icon.svg",
		text: "Templates Settings",
		isDisabled: this.checkTemplateDisable(),
	},
	{
		type: 'callback',
		id: 3,
		to: "/test-template",
		img: "/assets/svg/myLibrary/settings-menu/re-publish.svg",
		text: "Republish Queue"
	}];


	constructor(props: ContentTopMenuProps, state: ContentTopMenuState) {
		super(props);
	}

	// handleRepublishQueue = () => {

	// }

	clicked = () => {
		this.props.handleRepublishQueue(true)
	}

	
	render() {
		const {isIndicator} = this.props;
		let menuI = this.menuItems;
		// {
		// 	if (!ACLService.hasAccessTo(['TAG'], ['VIEW'])) {
		// 		menuI = menuI.filter(m => m.id != 1);
		// 	}
		// 	if (!ACLService.hasAccessTo(['RULE'], ['VIEW'])) {
		// 		menuI = menuI.filter(m => m.id != 2);
		// 	}
		// }
		return (
			<>
			<MyPATPopMenu clicked={this.clicked} myLibraryTooltip={false} showIndicator={isIndicator} tooltipValue="Click to go to tag or template settings" id="settings-menu" icon={SettingsIcon} menuItem={menuI} />
			
			</>
		);
	}
}

// @ts-ignore
export default withStyles(styles)(ContentTopMenu);